import React from 'react';
import framework from 'utils/framework';
import useRoktPageView from 'hooks/useRoktPageView';
const { wrapFunctionalComponent } = framework;

import RecentOrders from 'components/RichProfile/MyAccount/RecentOrders/RecentOrders';
import ufeApi from 'services/api/ufeApi';

const Orders = () => {
    useRoktPageView({ pagetype: 'Orders', screenname: 'Order History', title: 'Order History' });

    return (
        <div>
            <RecentOrders requestCounter={ufeApi.getCallsCounter()} />
        </div>
    );
};

export default wrapFunctionalComponent(Orders, 'Orders');
